import { createStore } from 'owa-satcheljs';

const getObservableDateTimeStore: () => ObservableTimeStore = createStore('ObservableDateTime', {
    now: 0, // timestamp of 'now', updated every minute.
    today: 0, // timestamp of the start of 'today', in the user's time zone.
});

export interface ObservableTimeStore {
    now: number;
    today: number;
}

export default getObservableDateTimeStore;
